import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {
    ObjectBaseModeComponent
} from "../../../../../../../features/core/shared/object/mvs-object-base/object-base-mode.component";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'ol-outlet-content-type-base',
    template: '',
    standalone: false
})
export class OlOutletContentTypeBaseComponent extends ObjectBaseModeComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    navigationItems: NavigationItem[] = [
        {
            label: 'Inhaltstyp',
            action: 'outletContentType',
            tooltip: 'Outlet-Inhaltstyp',
            icon: 'fa-solid fa-layer-group',
            toggleable: false,
            default: true
        },
        {
            label: 'Felder',
            action: 'outletContentTypeField',
            tooltip: 'Inhaltstyp-Felder',
            icon: 'fa-solid fa-table-cells',
            toggleable: false,
            default: false
        },
        {
            label: 'Inhalte',
            action: 'outletContent',
            tooltip: 'Outlet-Inhalte',
            icon: 'fa-solid fa-file-lines',
            toggleable: false,
            default: false
        }
    ];

    outletContentTypeWidgetData: WidgetData;
    outletContentTypeFieldWidgetData: WidgetData;
    outletContentWidgetData: WidgetData;


    constructor(protected route: ActivatedRoute) {
        super(route)
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
        this.refreshWidget();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    refreshWidget() {
        this.outletContentTypeWidgetData = WidgetFactory.createWidgetEntityData(
            'ol.outlet.content.type.object.component.basic.widget',
            'Outlet-Inhaltstyp',
            'ol.OutletContentType',
            this.objectIdentifier.objectId
        );

        this.outletContentTypeFieldWidgetData = WidgetFactory.createWidgetTableEntityBasicQl('ol.outlet.content.type.object.component.type.field.widget', 'Inhaltstyp-Felder', 'ol.OutletContentTypeField', [FilterCriteria.create('e.typeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], []);

        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'typeDtoId', fieldValue: this.objectIdentifier.objectId}];

        this.outletContentTypeFieldWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.outletContentWidgetData = WidgetFactory.createWidgetTableEntityBasicQl('ol.outlet.content.type.object.component.content.widget', 'Outlet-Inhalte', 'ol.OutletContent', [FilterCriteria.create('e.typeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], []);

        this.outletContentWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
